export enum DeclineNotesEnum {
    ACTIVE = 1,
    INACTIVE = 2,
    EMAILNOTVERIFIED = 4,
    DOCUMENTPENDING = 5,
    EMAILVERIFIED = 6,
    REJECTED = 8
}